import { createRoot } from 'react-dom/client'

import { Router } from './Router'

createRoot(document.querySelector('#root')!).render(<Router />)
